import React from "react"
import GifPlayer from "react-gif-player"

//helper functions to help with scrolling the gallery
//https://stackoverflow.com/questions/52747018/horizontal-scrolling-using-buttons-in-reactjs//
function scrollLeft(element, change, duration) {
    var start = element.scrollLeft,
        currentTime = 0,
        increment = 20;
    var animateScroll = function(){        
        currentTime += increment;
        var val = Math.easeInOutQuad(currentTime, start, change, duration);
        element.scrollLeft = val;
        if(currentTime < duration) {
            setTimeout(animateScroll, increment);
        }
    };
    animateScroll();
}

//t = current time
//b = start value
//c = change in value
//d = duration
Math.easeInOutQuad = function (t, b, c, d) {
  t /= d/2;
	if (t < 1) return c/2*t*t + b;
	t--;
	return -c/2 * (t*(t-2) - 1) + b;
};

class GameGallery extends React.Component{
    scrollRight = () =>{
        const galleryScroll = document.getElementsByClassName("galleryScroll")[0]
        scrollLeft(galleryScroll, -700, 500)
    }
    scrollLeft = () =>{
        const galleryScroll = document.getElementsByClassName("galleryScroll")[0]
        scrollLeft(galleryScroll, 700, 500)
    }

    render(){
        return(
            <div className="gameGallery">
                <div className="galleryContainer">
                    <div className="galleryScroll">
                        {this.props.data.galleryUrls.map(
                            img =>{ if (img.type === "image") return <img className="galleryPhoto" src={img.url} key={img.id} alt="gameGallery" />
                                    else if (img.type ==="gif") return <GifPlayer className="galleryPhoto" gif={img.url} key={img.id} />
                                    else return <iframe className="galleryPhoto" key={img.id} title={img.url}
                                    src={img.url} frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
                                    allowFullScreen
                                />
                        })}
                    </div>
                    <div className="prev" onClick={this.scrollRight}><i className="fas fa-angle-left"></i></div>
                    <div className="next" onClick={this.scrollLeft}><i className="fas fa-angle-right"></i></div>
                </div>
            </div>
        )
    }
}

export default GameGallery